import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IdName } from 'src/core/models';
import { 
  AgeGroupService, ArrayService, AuthService, ChurchService, 
  DatabaseService, DocumentService, FestivalUserService 
} from 'src/core/services';
import { NgForm } from '@angular/forms';
import { ModalController, AlertController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';

@Component({
  selector: 'app-edit-church',
  templateUrl: './edit-church.component.html',
  styleUrls: ['./edit-church.component.less', '../../core/styles/common.less']
})

export class EditChurchComponent extends PageClass implements OnInit {

  @Input() church: any;

  churchId: string;

  countryList: IdName[];
  stateList: IdName[];

  @ViewChild('editChurchForm', null) editChurchForm: NgForm;
  @ViewChild('closeModal', null)  closeModal: ElementRef;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private documentService: DocumentService,
    protected festivalUserService: FestivalUserService,
    private modalController: ModalController,
    public alertController: AlertController,
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {

      this.countryList = this.churchService.getCountryList();
      this.stateList = this.churchService.getAustraliaStateList();

      this.church.country = this.countryList.find(c => c.id === this.church.country.id);
      this.church.state = this.stateList.find(s => s.id === this.church.state.id);

    } else {
      this.dismissModal();
    }
  }

  public async editChurch() {
    if (this.editChurchForm.invalid) {
      return;
    }

    if (this.church.country.id !== 'AU') {
      this.church.state = null;
    }

    if (!this.church.state || this.church.state.id !== 'VIC') {
      this.church.isInterstate = true;
    }

    this.documentService.updateDocument(this.churchService.collection, this.church);

    this.dismissModal();
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
